import React, { useEffect, lazy, createElement } from 'react';
import { Star } from 'lucide-react';
export function MCBedanktPage() {
  useEffect(() => {
    // Load Tally embed script and (re)load embeds
    const w = 'https://tally.so/widgets/embed.js';
    const loadEmbeds = () => {
      const Tally = (window as any).Tally;
      if (typeof Tally !== 'undefined') {
        Tally.loadEmbeds();
      } else {
        document.querySelectorAll('iframe[data-tally-src]:not([src])').forEach(e => {
          ;
          (e as HTMLIFrameElement).src = (e as HTMLIFrameElement).dataset.tallySrc as string;
        });
      }
    };
    if (typeof (window as any).Tally !== 'undefined') {
      loadEmbeds();
    } else if (document.querySelector(`script[src="${w}"]`) == null) {
      const script = document.createElement('script');
      script.src = w;
      script.onload = loadEmbeds;
      script.onerror = loadEmbeds;
      document.body.appendChild(script);
    }
  }, []);
  // Fire Meta Pixel conversion events (with retry if fbq not ready yet)
  useEffect(() => {
    const fireEvents = () => {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'Lead');
        (window as any).fbq('track', 'Masterclass Signup');
        return true;
      }
      return false;
    };
    if (!fireEvents()) {
      // Retry every 500ms for up to 5 seconds
      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
        if (fireEvents() || attempts >= 10) {
          clearInterval(interval);
        }
      }, 500);
      return () => clearInterval(interval);
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-[#142d52]" data-id="element-2822" data-mp="10hnv6x7n50cg">
      {/* Hero Section */}
      <section className="py-12 px-4 flex flex-col items-center text-center" data-id="element-2823" data-mp="15a7hqjob35te">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 max-w-3xl" data-id="element-2824" data-mp="8rt3wv0830l5">
          Yes! Je hebt een plekje bemachtigd voor de Masterclass!
        </h1>

        <div className="w-full max-w-3xl mb-6" data-id="element-2825" data-mp="cqs7oca7wrb0">
          <div style={{
          padding: '56.25% 0 0 0',
          position: 'relative'
        }} data-id="element-2826" data-mp="1g30oafp4k8zz">
            <iframe src="https://player.vimeo.com/video/727758719?h=e9202f5a5e&title=0&byline=0&portrait=0" style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Bedankt video" data-id="element-2827" data-mp="1b4fm4aqbbf8w"></iframe>
          </div>
        </div>

        <p className="text-sm text-gray-600 italic" data-id="element-2828" data-mp="1639tse0kdtzw">
          Lees dan hieronder even verder om te zien hoe je het meeste uit deze
          Masterclass haalt...
        </p>
      </section>

      {/* Dark Banner */}
      <section className="bg-[#333333] py-6 px-4 text-center" data-id="element-2829" data-mp="2djg6r4njc2cn">
        <h2 className="text-white text-xl md:text-2xl font-bold" data-id="element-2830" data-mp="2diwqdsdj9m0q">
          Zo mis je niets en ben je goed voorbereid:
        </h2>
      </section>

      {/* Steps Section with Background Image */}
      <section className="relative py-16 px-4 bg-cover bg-center bg-fixed" style={{
      backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/5cB7x4JBKLA2SGnQ1mna3u/Scherm%C2%ADafbeelding_2025-08-15_om_15.46.41.png)'
    }} data-id="element-2831" data-mp="2q33flrjku2o4">
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/60" data-id="element-2832" data-mp="33vjbm8e290fj"></div>

        <div className="relative z-10 max-w-3xl mx-auto space-y-8" data-id="element-2833" data-mp="38qynwvwf6o9u">
          {/* Step 1 */}
          <div className="bg-white/95 rounded-sm overflow-hidden shadow-xl" data-id="element-2834" data-mp="2u2lyyivr25ou">
            <div className="bg-[#48c4c4] py-4 px-6 text-center" data-id="element-2835" data-mp="2z1oth9e3stik">
              <h3 className="text-white text-xl font-bold italic" data-id="element-2836" data-mp="2z03zplzm5elr">
                1 - Laat ons weten wat je echt wilt leren
              </h3>
            </div>
            <div className="p-6" data-id="element-2837" data-mp="3rjj8zr5vnp33">
              <iframe data-tally-src="https://tally.so/embed/Pdroed?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1" loading="lazy" width="100%" height="225" frameBorder="0" marginHeight={0} marginWidth={0} title="Webinar Reminder Aanmelding" data-id="element-2838" data-mp="3rkm3e92es9nr"></iframe>
            </div>
          </div>

          {/* Step 2 */}
          <div className="bg-white/95 rounded-sm overflow-hidden shadow-xl" data-id="element-2839" data-mp="2mkec8zac5y3o">
            <div className="bg-[#48c4c4] py-4 px-6 text-center" data-id="element-2840" data-mp="2hmw0z28uj6si">
              <h3 className="text-white text-xl font-bold italic" data-id="element-2841" data-mp="2cuurtp6z5w6p">
                2 - Controleer je email en zet de Masterclass in je Agenda
              </h3>
            </div>
            <div className="p-6 text-center space-y-4" data-id="element-2842" data-mp="27u72d7ye9nel">
              <p className="font-semibold" data-id="element-2843" data-mp="35cgswamz9edx">
                Je ontvangt zo direct een bevestigings email met de link naar de
                Masterclass. Heb je deze niet ontvangen?
              </p>
              <p className="text-sm" data-id="element-2844" data-mp="38ue9xql86dr3">
                Check dan even je spambox of reclame folder.
              </p>
              <p className="font-bold text-lg mt-6" data-id="element-2845" data-mp="3cvgbie2m71w8">
                Voor de zekerheid: zet de datum in je agenda. Klik op 'zet in de
                agenda' of voeg het handmatig toe.
              </p>
              <p className="font-bold" data-id="element-2846" data-mp="3mufdjdsvjza9">Hieronder zie je hoe dat eruit ziet:</p>

              <div className="border border-gray-200 rounded p-4 bg-white mt-4 text-left text-sm" data-id="element-2847" data-mp="3rrfitmhwgy0b">
                <div className="flex items-center gap-2 mb-2 text-gray-500" data-id="element-2848" data-mp="3vshksb37bo5z">
                  <span className="font-bold" data-id="element-2849" data-mp="4euzspillupf">Amee de Bruijn</span> via
                  webinargeek.com
                </div>
                <div className="font-bold mb-2" data-id="element-2850" data-mp="9cwmdkf8gc5n">
                  Aanmelding Masterclass Communiceren met je Hond
                </div>
                <div className="bg-blue-50 p-3 rounded border border-blue-100 flex items-center gap-4" data-id="element-2851" data-mp="ebhkneaxclrg">
                  <div className="bg-blue-600 text-white p-2 rounded text-center leading-tight" data-id="element-2852" data-mp="3ptnmrr4a685i">
                    <div className="text-xs" data-id="element-2853" data-mp="3kukt12tr3ocu">APR</div>
                    <div className="font-bold text-lg" data-id="element-2854" data-mp="3kvvswrk2sbyo">5</div>
                  </div>
                  <div data-id="element-2855" data-mp="3f4joqkrafec">
                    <div className="font-bold text-blue-800" data-id="element-2856" data-mp="3fmgbobbyvms">
                      Masterclass Communiceren met je Hond
                    </div>
                    <div className="text-blue-600 text-xs" data-id="element-2857" data-mp="cehkyvyq7xnz">Zet in agenda</div>
                  </div>
                </div>
              </div>

              <p className="text-sm font-semibold mt-4" data-id="element-2858" data-mp="7f4y4b7uuqle">
                15 minuten voorafgaand aan de Masterclass ontvang je nogmaals
                een e-mail met de link.
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="bg-white/95 rounded-sm overflow-hidden shadow-xl" data-id="element-2859" data-mp="2o40n3pbk2nik">
            <div className="bg-[#48c4c4] py-4 px-6 text-center" data-id="element-2860" data-mp="2o652b3ewn8y5">
              <h3 className="text-white text-xl font-bold italic" data-id="element-2861" data-mp="2j6ilkjzvbakl">
                3 - Tijdens de Masterclass
              </h3>
            </div>
            <div className="p-8 text-center space-y-4 text-sm leading-relaxed" data-id="element-2862" data-mp="13m9mnfnjbpvy">
              <p data-id="element-2863" data-mp="13oc9jqte52wg">
                De Masterclass is live (en niet vooraf opgenomen). Dat betekent
                dat ik er echt ben en je vragen kan beantwoorden via de chat. Ik
                vind het super leuk als je actief meedoet en vragen stelt!
              </p>
              <p data-id="element-2864" data-mp="fv3x28rslj8g">
                Tijdens de Masterclass gaan we het hebben over de 3 grootste
                misverstanden die hondenbaasjes maken. We gaan het hebben over
                de taal van je hond en hoe je zelf kunt communiceren met je
                hond.
              </p>
              <p className="font-bold mt-6" data-id="element-2865" data-mp="aydijpvmyvp5">
                Zorg dat je een rustig plekje hebt om de Masterclass te volgen
                met een kopje thee of koffie en een notitieblokje.
              </p>
            </div>
          </div>

          {/* Step 4 */}
          <div className="bg-white/95 rounded-sm overflow-hidden shadow-xl" data-id="element-2866" data-mp="s4ihbo4mz07j">
            <div className="bg-[#48c4c4] py-4 px-6 text-center" data-id="element-2867" data-mp="s6laui4zzbh0">
              <h3 className="text-white text-xl font-bold italic" data-id="element-2868" data-mp="o3ouyz6udtgr">
                4 - Volg mij op social media
              </h3>
            </div>
            <div className="p-8 text-center space-y-6 text-sm" data-id="element-2869" data-mp="edlru660az4p">
              <p data-id="element-2870" data-mp="eb9e657a7axg">
                Op social media deel ik dagelijks tips, tricks en een kijkje
                achter de schermen. Ik vind het super leuk om in contact te
                komen met andere hondenbaasjes, dus stuur me gerust een
                berichtje!
              </p>

              <div className="space-y-2" data-id="element-2871" data-mp="dukgo9zwgzo">
                <p data-id="element-2872" data-mp="3rk5gg605erk5">
                  <span className="font-bold" data-id="element-2873" data-mp="3rknmfucm4k59">Facebook:</span>{' '}
                  <a href="https://www.facebook.com/stresslessdogs.nl/" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline" data-id="element-2874" data-mp="1urlp19dgwao9">
                    https://www.facebook.com/stresslessdogs.nl/
                  </a>
                </p>
                <p data-id="element-2875" data-mp="229jxrbntrhqf">
                  <span className="font-bold" data-id="element-2876" data-mp="2291uvw6nq59j">Instagram:</span>{' '}
                  <a href="https://www.instagram.com/stresslessdogs.nl/" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline" data-id="element-2877" data-mp="2735yq6kmlx6e">
                    https://www.instagram.com/stresslessdogs.nl/
                  </a>
                </p>
                <p data-id="element-2878" data-mp="1oau09ux3fg1j">
                  <span className="font-bold" data-id="element-2879" data-mp="1oaage8nvuhkv">YouTube:</span>{' '}
                  <a href="https://www.youtube.com/@stresslessdogs" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline" data-id="element-2880" data-mp="1scozmtvgrjco">
                    https://www.youtube.com/@stresslessdogs
                  </a>
                </p>
                <p data-id="element-2881" data-mp="yfbzw35jc83i">
                  <span className="font-bold" data-id="element-2882" data-mp="ydsjmcjvpx1q">TikTok:</span>{' '}
                  <a href="https://www.tiktok.com/@stresslessdogs.nl" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline" data-id="element-2883" data-mp="13dnaig3nmmms">
                    https://www.tiktok.com/@stresslessdogs.nl
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Step 5 */}
          <div className="bg-white/95 rounded-sm overflow-hidden shadow-xl" data-id="element-2884" data-mp="ki6oroqysj1e">
            <div className="bg-[#48c4c4] py-4 px-6 text-center" data-id="element-2885" data-mp="pdm0ob5ew4v6">
              <h3 className="text-white text-xl font-bold italic" data-id="element-2886" data-mp="uejr1b0ks57r">
                5 - Bekijk reviews
              </h3>
            </div>
            <div className="p-6 space-y-6" data-id="element-2887" data-mp="20u2j8dc9j1m9">
              <p className="text-center font-bold text-sm mb-6" data-id="element-2888" data-mp="25t6tl7axb5e6">
                Hieronder kan je lezen wat andere baasjes er van vonden
              </p>

              {/* Review 1 */}
              <div className="flex gap-4" data-id="element-2889" data-mp="3lcecdsrdvde8">
                <div className="w-10 h-10 bg-blue-600 text-white rounded flex items-center justify-center font-bold flex-shrink-0" data-id="element-2890" data-mp="3ldphpx0h8t7g">
                  V
                </div>
                <div data-id="element-2891" data-mp="3bn39inv3b4ys">
                  <div className="flex items-center gap-2 mb-1" data-id="element-2892" data-mp="3bls5cmxqfv75">
                    <span className="font-bold text-sm" data-id="element-2893" data-mp="36n8kkpuvkpgd">Veerle</span>
                    <span className="text-xs text-gray-500" data-id="element-2894" data-mp="36ldvr0ghgd70">10:33</span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-2895" data-mp="32nzohecd4fhn">
                    Bedankt voor je lezing, je hebt op een duidelijke manier en
                    met concrete voorbeelden veel inzicht bijgebracht! Iets wat
                    ik in de toekomst ook graag zou gaan doen. Veel succes nog
                    en ik volg je nog op FB.
                  </p>
                </div>
              </div>

              {/* Review 2 (Email style) */}
              <div className="border-t border-gray-200 pt-4" data-id="element-2896" data-mp="2lcawclkqjo6n">
                <div className="text-xs text-gray-500 mb-2" data-id="element-2897" data-mp="2laq1euuie389">
                  <span className="font-bold" data-id="element-2898" data-mp="2q42nax7szvxb">Jessica</span> aan mij
                </div>
                <p className="text-sm font-bold mb-2" data-id="element-2899" data-mp="2bfg3ai78efzr">Hi Amee,</p>
                <p className="text-sm text-gray-700 mb-2" data-id="element-2900" data-mp="2gd80nrqnaubc">
                  Super, het is gelukt. Dankjewel!
                </p>
                <p className="text-sm text-gray-700 mb-2" data-id="element-2901" data-mp="3443romna1lhj">
                  Ik wilde nog mijn complimenten geven voor de masterclass van
                  gisteren. Ik heb menig gratis webinars gevolgd en vond die van
                  jou echt wel de beste. Ben benieuwd naar de cursussen!
                </p>
                <p className="text-sm text-gray-700" data-id="element-2902" data-mp="2z2ed4x0uipop">Groeten, Jessica</p>
              </div>

              {/* Review 3 (Google style) */}
              <div className="border-t border-gray-200 pt-4" data-id="element-2903" data-mp="1nospxhejqy5t">
                <div className="flex items-center gap-3 mb-2" data-id="element-2904" data-mp="1nqdjb3p4kb23">
                  <div className="w-10 h-10 bg-orange-200 rounded-full flex items-center justify-center font-bold text-orange-700" data-id="element-2905" data-mp="5qnx4625jdua">
                    K
                  </div>
                  <div data-id="element-2906" data-mp="ervp66e2rifx">
                    <div className="font-bold text-sm" data-id="element-2907" data-mp="es5f5tz4dplm">Kees van Damme</div>
                    <div className="text-xs text-gray-500" data-id="element-2908" data-mp="aqjsxi0p3yyr">
                      Local Guide · 122 reviews · 114 foto's
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2 mb-2" data-id="element-2909" data-mp="3e6zb1kuvt9ku">
                  <div className="flex text-yellow-400" data-id="element-2910" data-mp="3e8k6dcp0swjr">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-2911" data-mp="3rzp0jz9mcwmp" data-mpi={i} />)}
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-2912" data-mp="3n5ufosia2bm1">
                    9 maanden geleden
                  </span>
                </div>
                <p className="text-sm text-gray-700" data-id="element-2913" data-mp="2vfg8ff4rrxjc">
                  Stressless dogs geeft veel goede gedetailleerde informatie.
                  Vooral de informatie hoe je met stressvolle situaties kunt
                  omgaan zoals curven, afstand houden etc zijn erg praktisch en
                  werken goed in de praktijk. Dagelijks heb ik er plezier van en
                  mijn honden ook!
                </p>
              </div>

              {/* Review 4 */}
              <div className="border-t border-gray-200 pt-4 flex gap-4" data-id="element-2914" data-mp="3rtzn0nc04ka0">
                <div className="w-10 h-10 bg-green-600 text-white rounded flex items-center justify-center font-bold flex-shrink-0" data-id="element-2915" data-mp="3rw2cn698sbe7">
                  B
                </div>
                <div data-id="element-2916" data-mp="4pjlpr99xouc">
                  <div className="flex items-center gap-2 mb-1" data-id="element-2917" data-mp="4n745f7fhght">
                    <span className="font-bold text-sm" data-id="element-2918" data-mp="9mrzzgrax8qb">Bianca</span>
                    <span className="text-xs text-gray-500" data-id="element-2919" data-mp="26gwpgczi9qot">21:31</span>
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-2920" data-mp="2bey5ep1mx9w2">
                    Bedankt voor deze Masterclass, heb er veel van opgestoken
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#111111] py-6 text-center text-xs text-gray-400" data-id="element-2921" data-mp="1u65cdnxlddb3">
        <p data-id="element-2922" data-mp="1u41afbj96odg">© 2025 Stressless Dogs. Alle rechten voorbehouden.</p>
      </footer>
    </div>;
}